import { useContext } from "react";
import { Switch } from "@blueprintjs/core";

import PageContext from "../Context/PageContext";

import SketchColor from "../Component/Card/SketchColor";

import { Chart as ChartJS, registerables } from "chart.js";
import uniqid from "uniqid";
import Helper from "../Component/Helper";
import { createAddElementAction } from "../history/element.history";


ChartJS.register(...registerables);

export default function ElevationSection() {

    const { addItem, mapListTrace, elevationData, chartRef, setChartRef,
        isElevationPresent, setIsElevationPresent, objItems, removeItem,
    history, selectedItem, setSelectedItem, setOpenAbsoluteMenuSection, setObjItems, } = useContext(PageContext);

    const options = {
        //responsive ne peut être à false sinon resize fonctionne pas
        //responsive: false,
        maintainAspectRatio: false,
        animation: false as const,
        devicePixelRatio: 6,
        plugins: {
            legend: {
                display: false,
                position: 'top' as const,
            },
            title: {
                display: false,
                text: 'Chart.js Line Chart',
            },
        },
        scales: {
            x: {
                ticks: {
                    display: false
                },
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                }
            },
            y: {
                ticks: {
                    display: false
                },
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                }
            }
        }
    };


    function addElevationProfile() {
        var json = {
            "id": "ll15wqyw",
            "type": "elevation-element",
            "class": "elevation-element",
            "style": {
                "font-size": "45px",
                "font-style": "italic",
                "font-weight": "bold",
                "color": "black",
                "text-align": "center",
                "text-decoration": "none",
                "opacity": 100,
            },
            "x": 0,
            "y": 0,
            "isLock": false,
            "width": "1000px",
            "height": "80px",
            "options": {},
            "data": {}
        }

        json.id = uniqid();
        json.options = options;
        json.data = elevationData;

        if (addItem != null) {
            addItem(json);

            //on sort la mécanique history hors de addItem pour éviter l'effet cyclique
            const action = createAddElementAction(json, { removeItem, selectedItem, setSelectedItem, setOpenAbsoluteMenuSection, addItem, setObjItems, objItems });
            history.add(action);
        }

    }

    function isDraggableMapFunction(event: React.FormEvent<HTMLInputElement>) {

        if (!isElevationPresent) {
            if ((chartRef == null || chartRef == undefined || chartRef.length == 0 || chartRef.current == undefined) && mapListTrace.length > 0) {
                addElevationProfile();
                if (setIsElevationPresent) setIsElevationPresent(true);
            }
        }
        else {
            if (setIsElevationPresent) setIsElevationPresent(false);
            const chartToDelete = objItems.find(item => item.class === 'elevation-element');
            if (removeItem) removeItem(chartToDelete.id);
            if (setChartRef) setChartRef(null);
        }

    }

    return (
        <div style={{ width: '100%' }}>
            <div className="subtitle-section">
                <h3 > Dénivelé </h3>
                <Helper text="Ajoute le dénivelé de ton parcours pour illustrer sa difficulté, puis ajuste sa couleur pour qu'elle s'accorde avec ton affiche​​" />
            </div>
            <div>
                {mapListTrace.length == 0 && <div>Ajouter un itinéraire pour générer un profil dénivelé</div>}

                {mapListTrace.length > 0 && <div className="switch-denivele-map">
                    <Switch style={{ marginBottom: 0 }} onChange={isDraggableMapFunction} checked={isElevationPresent} innerLabelChecked="oui" innerLabel="non" />
                    <label htmlFor="">Ajouter le profil dénivelé</label>
                </div>}

                {isElevationPresent && <div>
                    <div className="background-color-page">
                        <div className="label-side-menu">Couleur de fond </div>
                        <div className="background-color-page-picker">
                            <SketchColor elem={'elevation-bg'} color={(elevationData != null /*&& elevationData.length > 0*/) ? elevationData.datasets[0].backgroundColor : '#000000'} />
                        </div>
                    </div>

                    <div className="background-color-page">
                        <div className="label-side-menu">Couleur de la bordure </div>
                        <div className="background-color-page-picker">
                            <SketchColor elem={'elevation-bordure'} color={(elevationData != null /*&& elevationData.length > 0*/) ? elevationData.datasets[0].borderColor : '#000000'} />
                        </div>
                    </div>
                </div>
                }

            </div>
        </div>
    );
}